import { PaletteOptions } from "@mui/material";

const palette: PaletteOptions = {
  mode: "light",
  primary: {
    main: "#2D6CE1", //former: #3368F4
    mainHover: "#1D59C9", //former: linear-gradient(0deg, rgba(255, 255, 255, 0.05), rgba(255, 255, 255, 0.05)), #3368F4
    mainPressed: "#2D6CE1", //former: rgba(0, 53, 194, 0.1)
    text: "#2456B4", // former: "#4194FD"
    contrastText: "#FFFFFF",
    alpha: "rgba(45, 108, 225, 0.2)", //former: "rgba(51, 104, 244, 0.15)",
    alphaHover: "rgba(45, 108, 225, 0.3)", //former: "rgba(0, 53, 194, 0.2)",
    alphaPressed: "rgba(45, 108, 225, 0.1)", //former: "rgba(0, 53, 194, 0.1)",
  },
  //   primary: {
  //     main: "#7E3FF5", //former: #3368F4
  //     mainHover: "#7E3FF5", //former: linear-gradient(0deg, rgba(255, 255, 255, 0.05), rgba(255, 255, 255, 0.05)), #3368F4
  //     mainPressed: "#7E3FF5", //former: rgba(0, 53, 194, 0.1)
  //     text: "#7E3FF5", // former: "#4194FD"
  //     contrastText: "#FFFFFF",
  //     alpha: "rgba(126, 63, 245, 0.15)", //former: "rgba(51, 104, 244, 0.15)",
  //     alphaHover: "rgba(126, 63, 245, 0.2)", //former: "rgba(0, 53, 194, 0.2)",
  //     alphaPressed: "rgba(126, 63, 245, 0.1)", //former: "rgba(0, 53, 194, 0.1)",
  //   },

  success: {
    main: "#12BA91",
    mainHover: "#35E9BD",
    dark: "#0C4034", // onMain-Text
    alpha: "rgba(31, 193, 154, 0.20)",
    alphaHover: "rgba(31, 193, 154, 0.3)",
    alphaPressed: "rgba(31, 193, 154, 0.10)",
  },
  warning: {
    main: "#FCA464",
    mainHover: "#FFBE8F",
    dark: "#40220C", // onMain-Text
    alpha: "rgba(252, 164, 100, 0.20)",
    alphaHover: "rgba(252, 164, 100, 0.3)",
    alphaPressed: "rgba(252, 164, 100, 0.1)",
  },
  error: {
    main: "#ED6273",
    mainHover: "#FB8E9B",
    dark: "#40160C", // onMain-Text
    alpha: "rgba(237, 98, 115, 0.2)",
    alphaHover: "rgba(237, 98, 115, 0.3)",
    alphaPressed: "rgba(237, 98, 115, 0.1)",
  },
  info: {
    // aka accent
    main: "#8442F0",
    mainHover: "#9B68EE",
    dark: "#210C75", // onMain-Text
    text: "#722DE1",
    alpha: "rgba(132, 66, 240, 0.2)",
    alphaHover: "rgba(132, 66, 240, 0.3)",
    alphaPressed: "rgba(132, 66, 240, 0.1)",
  },
  accent: {
    // aka yellow
    main: "#F7C035",
    mainHover: "#F9D372",
    contrastText: "#0E0E1B",
    alpha: "rgba(247, 192, 53, 0.2)",
    alphaHover: "rgba(247, 192, 53, 0.30)",
    alphaPressed: "rgba(247, 192, 53, 0.10)",
  },
  text: {
    primary: "#212125",
    secondary: "#55555E",
    tier: "#797986",
    placeholder: "#84848F",
    disabled: "#84848F",
    inverted: "#FFFFFF",
  },
  divider: "rgba(201, 201, 207, 0.4)",
  background: {
    page: "#ECECEE",
    paper: "#F3F3F4", //surface:01 former: #0E0E1B
    default: "#FAFAFA", //surface:00 //former: "#14141F"
    200: "#ECECEE", //former: "#161622"
    300: "#D7D7DB", //former: #22222B
    400: "#BCBCC2", //former: #3B3B4E
    inverted: "#000000",
    alphaHover: "rgba(201, 201, 207, 0.08)", //former: rgba(255, 255, 255, 0.08)
  },
  backgroundAlpha: {
    main: "rgba(201, 201, 207, 0.3)", // former white 0.05
    hover: "rgba(201, 201, 207, 0.4)", // former white 0.08
    pressed: "rgba(201, 201, 207, 0.20)", // former white 0.03
    border: "rgba(201, 201, 207, 0.4)", // former white 0.1
    borderFocus: "rgba(201, 201, 207, 0.55)", // former white 0.2
  },
  backgroundBoldAlpha: {
    main: "rgba(201, 201, 207, 0.2)", // former white 0.05
    hover: "rgba(201, 201, 207, 0.3)", // former white 0.08
    pressed: "rgba(201, 201, 207, 0.20)", // former white 0.03
    border: "rgba(201, 201, 207, 0.5)", // former white 0.1
    borderFocus: "rgba(201, 201, 207, 0.6)", // former white 0.2
  },
  absolute: {
    white: "#FFF",
    black: "#000",
  },
};

export default palette;
